import {
  ViewChild, Component, Directive, OnInit, ElementRef, AfterViewInit, NgZone, Inject, Input, Output, EventEmitter,
  OnDestroy, ViewEncapsulation
} from '@angular/core';
import {interval} from "rxjs";
import * as Communication from '../communication/index';
import {Router, ActivatedRoute} from '@angular/router';
import { Config } from '../../environments/environment';
//import { UploadOutput, UploadInput, UploadFile, humanizeBytes, UploaderOptions } from 'ngx-uploader';
//import {  HttpClient,  HttpEvent,  HttpEventType,  HttpHeaders,  HttpRequest,} from '@angular/common/http';

import {NavigationService} from "../shared/common/NavigationEventService";
import {FileConversionService} from "../shared/common/FileConversion.service";
import {NotificationService} from "../shared/common/NotificationService";
import {NavigationEvent} from "../shared/common/NavigationEvent";
import { Subscription } from 'rxjs';
import {Authorization} from "../shared/authorization/authorization.component";
import {TranslateService} from '@ngx-translate/core';
import Uppy, { UppyFile, AsyncStore } from '@uppy/core';
import Dashboard from '@uppy/dashboard';
import XHRUpload from '@uppy/xhr-upload';
import GoogleDrivePicker from "@uppy/google-drive-picker";
import Box from "@uppy/box";
import Turkish from '@uppy/locales/lib/tr_TR';
import English from '@uppy/locales/lib/en_US';
import { createInMemoryTokenStore } from '../shared/common/InMemoryTokenStore';

declare var $:any;


/**
 * This class represents the lazy loaded NewJobComponent.
 */
@Component({
    selector: 'sd-newJob',
    templateUrl: 'newJob.component.html',
    styleUrls: [
      'newJob.component.css',
      '../../../../node_modules/@uppy/core/dist/style.css',
      '../../../../node_modules/@uppy/dashboard/dist/style.css',
    ],
    providers: [Communication.JobsService, Communication.DocumentsService, Communication.RecipientRequestService],
    standalone: false,
    encapsulation: ViewEncapsulation.None,
})

export class NewJobComponent implements OnInit, OnDestroy {
  screenState: string = ""; // INITIAL -> UPLOADING -> FINISHED
  jobIDParameter:number;
  requestCode:string;
  theJob:Communication.Job;
  subscriptions:Subscription[] = [];
  //uploadFile: UploadFile;
  uploadedFiles: any[] = [];
  //files:UploadFile[] = [];
  uploadStatus = {"basladi": false, "bitti": false};
  uppy: Uppy;
  uppyDashboardOptions = {};


  sizeLimit = 100 * 1024 * 1024; //100MB
  maxFileCount:number = 50;
  progress:number;
  hasBaseDropZoneOver:boolean = false;
  @Output() refreshJob = new EventEmitter();

  //ngx-uploader objects
  startUploadEvent: EventEmitter<any>;
  //optionsMultiple:UploaderOptions = null;
  //optionsSingle:UploaderOptions = null;
  //uploadInput:EventEmitter<UploadInput>;
  isMultipleUpload:boolean = false;
  ismultipleUploadResponseArrived:boolean = false;
  uploadResponse: any;

  driveFSize:number;

  // Non-persistent, self-expiring store for the Google Drive picker OAuth token.
  private drivePickerStore: AsyncStore = createInMemoryTokenStore();
  private static readonly DRIVE_PICKER_TOKEN_KEY = 'uppy:google-drive-picker:accessToken';

  cloudFile:any = {
    "xhr":null,
    "fileName": "",
    "fileSize": "",
    "progress" : 0,
    "status": ""
  };

  isPlanSuitMultiUpload:boolean;
  templates:any=[];
  selectedTemplateId:number;
  templateCategories:any=[];
  selectedCategory:string;
  searchText:string;
  templateRecipients:any;
  recipientNames:any;
  disableEditRecBtn:boolean=false;

  //options: UploaderOptions;
  formData: FormData;
  //humanizeBytes: Function = humanizeBytes;
  multipleUploadFileCount:number;
  multipleUploadTotalFileSize:number;

  // Track ongoing Office file conversions
  private pendingConversions: number = 0;

  constructor(private jobsApi:Communication.JobsService,
              private documentsApi:Communication.DocumentsService,
              private recipientRequestApi:Communication.RecipientRequestService,
              private activatedRoute:ActivatedRoute,
              private router:Router,
              private route:ActivatedRoute,
              private navigationService:NavigationService,
              private zone:NgZone,
              private authorization: Authorization,
              private notificationService: NotificationService,
              public translate: TranslateService,
              private fileConversionService: FileConversionService,
  ) {

    //XMLHttpRequest.DONE = 4;
    this.theJob = null;
    this.progress = 0;

    this.uppy = new Uppy({
      debug: true,
      autoProceed: true,
      locale: this.translate.currentLang === 'tr' ? Turkish : English,
      restrictions: {
        maxNumberOfFiles: 100,
        allowedFileTypes: [
          'image/*',
          'application/pdf',
          ...FileConversionService.OFFICE_FILE_TYPES,
        ],
      },
      onBeforeUpload: (files) => {
          // Block upload while Office file conversions are in progress
          if (this.pendingConversions > 0) {
            console.log(`[Uppy] Blocking upload - ${this.pendingConversions} conversion(s) in progress`);
            return false;
          }

          // Block upload if there are still Office files (shouldn't happen after conversion)
          for (const [id, file] of Object.entries(files)) {
            if (this.fileConversionService.isOfficeFile(file.name)) {
              console.log(`[Uppy] Blocking upload - Office file not yet converted: ${file.name}`);
              return false;
            }
          }

          // Check if the number of files exceeds the maximum allowed
          if (Object.keys(files).length > 1) {
            if(this.authorization.userAccount.subscription.plan.multipleFiles != 'Y'){
              this.notificationService.showCurrentPlanNotSuitToDo(function (isConfirmed: boolean) { });
              return false;
            }
          }
          // You can add meta common to all files here:
        this.uppy.setMeta({
          // example: jobId: '123', userId: 'abc'
        });

        return true;
      },
      onBeforeFileAdded: (currentFile, files) => {
        // Remove trailing spaces and dots before file extension (e.g., 'filename . .pdf' -> 'filename.pdf')
        const originalName = currentFile.name;
        const sanitizedName = originalName.replace(/[\s.]+(\.[^.]+)$/, '$1');
        console.log('[Uppy] Filename sanitized:', originalName, '->', sanitizedName);

        if (currentFile.size > this.sizeLimit) {
          this.notificationService.largeFileToUpload();
          return false;
        }

        let match = FileConversionService.ALLOWED_FILE_REGEX.test(sanitizedName);
        if (!match) {
          this.notificationService.fileTypeNotMatchToUpload();
          return false;
        }

        // Block Office files from cloud providers (conversion not supported for remote files)
        const isRemoteFile = currentFile.isRemote || ['GoogleDrive', 'Box'].includes(currentFile.source as string);
        if (isRemoteFile && this.fileConversionService.isOfficeFile(sanitizedName)) {
          this.uppy.info(this.translate.instant('Office files from cloud storage must be downloaded and uploaded locally for PDF conversion'), 'error', 5000);
          return false;
        }

        if(!this.isMultipleUpload && sanitizedName.length > 250){
          this.notificationService.fileNameTooLong();
          return false;
        }

        if(this.isMultipleUpload){
          if(this.authorization.userAccount.subscription.plan.multipleFiles != 'Y'){
            this.notificationService.showCurrentPlanNotSuitToDo(function (isConfirmed: boolean) {
              if (isConfirmed) {
              }
            })
            return false;
          }
        }

        // Return modified file object with sanitized name (Uppy requires returning the modified object)
        return {
          ...currentFile,
          name: sanitizedName,
          meta: {
            ...currentFile.meta,
            name: sanitizedName,
          },
        };
      }
    });
    // plugins: ['Webcam'],
    //   inline: true,
    //   note: this.translate.instant('Only image and PDF files are allowed.'),
    //   metaFields: [
    //     { id: 'name', name: this.translate.instant('Name'), placeholder: this.translate.instant('file name') },
    //     { id: 'caption', name: this.translate.instant('Caption'), placeholder: this.translate.instant('describe what the file is about') }
    //   ],
    //   target: '#drag-drop-area',
    this.uppyDashboardOptions = {
      replaceTargetContent: true,
       browserBackButtonClose: false,
       height: 300,
       showProgressDetails: true,
      proudlyDisplayPoweredByUppy: false,
    };

    this.uppy.use(XHRUpload, {
      endpoint: Config.WEBSERVICEURL + '/jobs/document',
      method: 'POST',
      formData: true,
      fieldName: 'file',
      bundle: false,
    });

    // Ensure Authorization header is fresh for each upload
    this.uppy.on('upload', async () => {
      const token = this.authorization.getAccessToken();
      const xhr = this.uppy.getPlugin<XHRUpload<any, any>>('XHRUpload');

      xhr?.setOptions({
        headers: {
          'access_token': `${token}`,
        }
      });
    });

    this.uppy.on('complete', async (result) => {
      const ok = result.successful ?? [];
      if (ok.length === 1) {
        // Single file uploaded successfully
        const first = ok[0];
        // XHRUpload response body (assuming your API returns JSON)
        const body = (first?.response as any)?.body;
        this.uppy.clear();
        // Try to get an "id"—adapt this to your API:
        const id = body?.id ?? body?.data?.id ?? first?.meta?.serverId;
        if (id !== undefined) {
          document.getElementById("closeModalButtonCloseOnly").click();
          await this.router.navigate(['/doc', id]);
        }
      } else if (ok.length > 1) {
        // More than 1 file uploaded: reset and tell parent to close modal
        this.uppy.clear();
        document.getElementById("closeModalButtonCloseOnly").click();
        setTimeout(() => {
          this.refreshJob.emit({
            isMultiUpload: true
          });
        }, 300);

      }
      // If zero successful (all failed), do nothing special here
    });

    // Log upload errors for debugging
    this.uppy.on('upload-error', (file, error, response) => {
      console.error('[Uppy] Upload error for file:', file?.name);
      console.error('[Uppy] Error:', error);
      console.error('[Uppy] Response status:', response?.status);
      console.error('[Uppy] Response body:', response?.body);
    });

    this.uppy.use(GoogleDrivePicker, {
      companionUrl: Config.COMPANION_URL,
      clientId: Config.GOOGLE_PICKER_CLIENT_ID,
      apiKey: Config.GOOGLE_PICKER_API_KEY,
      appId: Config.GOOGLE_PICKER_APP_ID,
      // Non-persistent store — consumed at GoogleDrivePicker.js `this.opts.storage`.
      // `storage` is omitted from the public options type, hence the cast.
      storage: this.drivePickerStore,
    } as any);
    this.uppy.use(Box, {
      companionUrl: Config.COMPANION_URL,
      companionAllowedHosts: [new URL(Config.COMPANION_URL).origin],
    });

    // Convert Office files to PDF when added
    this.uppy.on('file-added', async (file) => {
      if (this.fileConversionService.isOfficeFile(file.name)) {
        console.log(`[Uppy] Converting Office file to PDF: ${file.name}`);

        // Check if file data is available (local files have data immediately)
        if (file.data instanceof Blob) {
          this.pendingConversions++;
          console.log(`[Uppy] Pending conversions: ${this.pendingConversions}`);

          try {
            // Convert to PDF
            const pdfBlob = await this.fileConversionService.convertToPdf(file as { data: Blob; name: string });
            const pdfName = this.fileConversionService.getPdfFileName(file.name);

            console.log(`[Uppy] Conversion complete: ${file.name} -> ${pdfName}`);

            // Preserve original file's metadata
            const originalMeta = { ...file.meta };

            // Remove original Office file
            this.uppy.removeFile(file.id);

            // Add converted PDF
            this.uppy.addFile({
              name: pdfName,
              type: 'application/pdf',
              data: pdfBlob,
              source: file.source || 'Local',
              isRemote: false,
              meta: originalMeta,
            });
          } catch (error) {
            console.error(`[Uppy] Conversion failed for ${file.name}:`, error);
            this.uppy.removeFile(file.id);
            this.notificationService.displayError(`Failed to convert ${file.name} to PDF`);
          } finally {
            this.pendingConversions--;
            console.log(`[Uppy] Pending conversions after: ${this.pendingConversions}`);

            // If all conversions done, trigger upload manually
            if (this.pendingConversions === 0) {
              const files = this.uppy.getFiles();
              if (files.length > 0) {
                console.log(`[Uppy] All conversions complete, starting upload with ${files.length} file(s)...`);
                // Small delay to ensure state is updated
                setTimeout(() => this.uppy.upload(), 100);
              }
            }
          }
        }
        // Remote Office files are blocked in onBeforeFileAdded
      }
    });




    //this.uploadInput = new EventEmitter<UploadInput>();
    // this.optionsSingle = {
    //   concurrency:1,
    //   maxUploads:1,
    //   allowedContentTypes:["image/jpg","image/jpeg","image/gif","image/png","application/pdf"],
    //   maxFileSize:this.sizeLimit
    // }
    // this.optionsMultiple = {
    //   concurrency:1,
    //   maxUploads:this.maxFileCount,
    //   allowedContentTypes:["image/jpg","image/jpeg","image/gif","image/png","application/pdf"],
    //   maxFileSize:this.sizeLimit * 10
    // }
    // this.files = []; // local uploading files array
    // this.humanizeBytes = humanizeBytes;
  }

  ngOnInit() {

    if (!this.authorization.authenticated()) {
      this.router.navigate(['/']);
    } else {

      this.initLazyLoadVariable();

      //this.zone = new NgZone({enableLongStackTrace: false});
      this.subscriptions.push(this.navigationService.eventOccured$.subscribe(
        (event: NavigationEvent) => this.onNavigationEvent(event)
      ));

      this.subscriptions.push(this.activatedRoute.queryParams.subscribe(
        (param: any) => {
          this.jobIDParameter = param['jobID'];
          console.log("jobIDParameter:" + this.jobIDParameter);
        }));

      // #newJob is a persistent CSS-toggled modal — the Uppy instance and its token store
      // survive across opens. Clear the cached Drive token on each open so a
      // re-authentication always starts fresh and never feeds a stale token to the picker.
      $('#newJob').on('shown.bs.modal.driveTokenReset', () => {
        this.drivePickerStore?.removeItem(NewJobComponent.DRIVE_PICKER_TOKEN_KEY);
      });

    }
  }

  initLazyLoadVariable() {
    //stop timer when initialize
    let timerSubscription = interval(500).subscribe(x => {

      if(this.authorization.userAccount !== null &&
        this.authorization.userAccount.hasOwnProperty("subscription") &&
        this.authorization.userAccount.subscription.hasOwnProperty("plan"))
      {
        if (timerSubscription != null)
          timerSubscription.unsubscribe();

        this.isPlanSuitMultiUpload = this.authorization.userAccount.subscription.plan.multipleFiles == 'Y';
      }

    });
  }

  getTemplates(){
    this.subscriptions.push(this.jobsApi.templatesGet(this.authorization.getAccessToken(), "system", "all").subscribe(
      (response: any) => {
        this.templates = response;
        console.log("templates ", this.templates);
        this.templateCategories = [];
        this.templateCategories = Array.from(new Set(this.templates.map((item: any) => item.category)));
        this.templateCategories.splice( 0, 0, this.translate.instant("All"));

      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }));
  }

  editTemplateRecipients(template:any) {
    this.selectedTemplateId = template.id;

    this.recipientNames = template.recipients.map(function (item:any) { return {  "name": item.name } });
    this.templateRecipients =  template.recipients
      .map(function (item:any) {
        return {
          "id": item.id,
          "name": item.name,
          "email": item.email,
          "citizenId": item.citizenId
        }
      });

    setTimeout(function () {
      $('#updateTemplateJobRecipients').modal('show');
    },0)

  }

  fillRecipientWithMyInfo(index:any) {
     this.templateRecipients[index].name = this.authorization.userProfile.user_metadata.name;
     this.templateRecipients[index].email = this.authorization.userProfile.email;

  }


  validateForm(form:any):boolean {
    let isActive=true;

    for(let i=0; i<form.coll.length; i++) {
      if(!form.coll[i])
        return false;
    }

    return isActive;
  }

  createJobFromTemplate(form:any) {
    this.disableEditRecBtn=true;

    if(!this.validateForm(form)) {
      this.disableEditRecBtn=false;
      return;
    }

    let recipientEmails = Array.from(new Set(this.templateRecipients.map((item: any) => item.email)));

    if(this.templateRecipients.length != recipientEmails.length) {
      this.notificationService.recipientUsedMoreThanOne();
      this.disableEditRecBtn=false;
      return;
    }

    let removeRight:string = this.authorization.userAccount.subscription.plan.removeOwnRecipient;
    let usageOfUserEmail = this.templateRecipients.filter((x:any) => x.email == this.authorization.userProfile.email);

    if(removeRight != 'Y' && usageOfUserEmail.length == 0) {
      this.notificationService.oneOfRecipientsShouldIncludeUserEmail();
      this.disableEditRecBtn=false;
      return;
    }

    this.subscriptions.push(this.jobsApi.jobsSystemTemplateIdPost(this.authorization.getAccessToken(), this.selectedTemplateId, JSON.stringify(this.templateRecipients)).subscribe(
      (response: Communication.Job) => {
        console.log("job created from template....");

        $('#updateTemplateJobRecipients').modal('hide');
        this.notificationService.jobCreatedFromTemplate();

        this.router.navigate(['/doc', response.id]);

      }, //Bind to view
      (err: any) => {
        // Log errors if any
        console.log(err);
        this.disableEditRecBtn = false;
        this.notificationService.displayError(err);
      }));
  }

  hideEditRecipientModal() {
    $('#updateTemplateJobRecipients').modal('hide');
  }

  upload(blobOrFile:any, fileName:string, source:string) {

    let tmpB64String = encodeURIComponent(blobOrFile);
    this.cloudFile.status = "Uploading file";
    this.cloudFile.progress = 0;

    let xhr = new XMLHttpRequest();
    let self = this;
    self.cloudFile.xhr = xhr;

    xhr.onload = function() {
      self.screenState = "FINISHED";

      if(xhr.status == 200) {

        console.log("The transfer is complete.");
        self.cloudFile.status = "File uploaded";
        document.getElementById("closeModalButton").click();
      }else{

        let uploadResponse = JSON.parse(xhr.response);
        console.log("Error during cloud upload: " + xhr.response);

        //if error occurs
        if(uploadResponse.hasOwnProperty('code')) {
          //console.log("response " + self.uploadResponse.description);
          self.cloudFile.status = "";
          self.cloudFile.progress = 0;
          self.notificationService.displayError(uploadResponse.description);
          self.initUploader();
        }
      }
    };

    let params = "fileName="+fileName + "&fileData="+tmpB64String + "&source="+source;

    xhr.open('POST', Config.WEBSERVICEURL + '/jobs/' + this.theJob.id + '/documents/cloud');

    xhr.upload.addEventListener("progress", function(e:any){
      if (e.lengthComputable) {
        self.cloudFile.progress = ((e.loaded / e.total) *100 ).toString().split('.')[0];
        //console.log("Uploaded:..." + e.loaded + "/" + e.total);
      }
    }, false);

    xhr.setRequestHeader('access_token', String(this.authorization.getAccessToken()));
    xhr.setRequestHeader('Content-Type',  'application/x-www-form-urlencoded' /*'application/json' 'text/plain' */);

    // Send the data
    xhr.send(params);
  }


  public newJob() {
    this.recipientNames = [];
    this.templateRecipients = [];
  }

  public onCancel() {
    // if (this.uploadFile !== null) {
    //   this.uploadInput.emit({type:"cancelAll"})
    // }

    //cancel Box or Drive upload
    if(this.cloudFile.xhr) {
      this.cloudFile.xhr.abort();
      this.cloudFile.xhr = null;

      this.cloudFile.status = "";
      this.cloudFile.progress = 0;
    }
  }

  private initUploader() {
    // this.uploadFile = null;
    this.screenState = "INITIAL";
    if(this.isMultipleUpload){
      this.ismultipleUploadResponseArrived = false;
    }
  }

  getMultipleUploadFileCount(event:FileList){
    this.multipleUploadFileCount = event.length;
    this.multipleUploadTotalFileSize = 0;
    for(let i=0;i<event.length;i++){
      this.multipleUploadTotalFileSize += event.item(i).size;
    }
  }

  onUploadOutput(output: any/*UploadOutput*/) {
    // console.log(output.type)
    switch (output.type) {
      case 'allAddedToQueue':{
        let url = Config.WEBSERVICEURL + '/jobs/' + this.theJob.id + '/documents';
        if(this.isMultipleUpload){ url = Config.WEBSERVICEURL + '/jobs/document'; }

        if(this.multipleUploadFileCount > this.maxFileCount || this.multipleUploadTotalFileSize > 200 * 1024 * 1024){
          // this.uploadInput.emit({type:"removeAll"});
          this.notificationService.largeFileToUpload();
          return;
        }

        if(!this.isMultipleUpload && this.cloudFile.fileName.length > 250){
          // this.uploadInput.emit({ type: 'removeAll' })
          this.notificationService.fileNameTooLong();
          this.cloudFile = {
            "xhr":null,
            "fileName": "",
            "fileSize": "",
            "progress" : 0,
            "status": ""
          };
          return;
        }

        // this.uploadInput.emit({
        //   type:"uploadAll",
        //   url: url,
        //   method:"POST",
        //   headers:{
        //     'access_token': this.authorization.getAccessToken()
        //   },
        //   id:this.theJob.id.toString()
        // });
      } break;
      case 'addedToQueue':{
        if (typeof output.file !== 'undefined') {
          this.beforeUpload(output.file);
        }
      } break;
      case 'uploading':{
        if (typeof output.file !== 'undefined') {
          // update current data in files array for uploading file
          // const index = this.files.findIndex(file => typeof output.file !== 'undefined' && file.id === output.file.id);
          // this.files[index] = output.file;
        }
      } break;
      case 'removed':{
        // remove file from array when removed
        // this.files = this.files.filter((file: UploadFile) => file !== output.file);
      } break;
      case 'start':{
        this.handleUpload(output.file);
        console.log(output)
      } break;
      case 'dragOver': {
        this.hasBaseDropZoneOver = true;
      } break;
      case 'dragOut':{
        this.hasBaseDropZoneOver = false;
      } break;
      case 'drop':{
        this.hasBaseDropZoneOver = false;
      } break;
      case 'done':{
        if(output.file && output.file.response && this.screenState != "FINISHED") {
          console.log("data && data.response ", output)

          if (this.uploadedFiles.indexOf(output.file) == -1) {
            this.uploadedFiles.push(output.file);
            console.warn("Uploaded Files: ", this.uploadedFiles.length)
          }

          this.uploadResponse = output.file.response;

          if(this.isMultipleUpload){
            if(this.multipleUploadFileCount == this.uploadedFiles.length){
              this.screenState = "FINISHED";
              document.getElementById("closeModalButtonCloseOnly").click();
              setTimeout(() => {
                this.refreshJob.emit({
                  isMultiUpload: this.isMultipleUpload
                });
              }, 300);
            }
          } else {
            this.router.navigate(['/doc', this.theJob.id]);
          }

          //if error occurs
          if (this.uploadResponse.hasOwnProperty('code')) {
            console.log("response " + this.uploadResponse.description);
            this.notificationService.displayError(this.uploadResponse.description);
            this.initUploader();
          }

        }
      } break;
      case 'rejected':{
        if (output.file.size > this.sizeLimit) {
          this.notificationService.largeFileToUpload();
        } else if (!(/\.(gif|jpg|jpeg|png|pdf)$/i).test(output.file.name)){
          this.notificationService.fileTypeNotMatchToUpload();
        }
      } break;
      case 'cancelled':{
        // this.uploadInput.emit({type:"removeAll"})
      } break;
    }
  }

  beforeUpload(uploadingFile: any/*UploadFile*/) {
    this.uploadedFiles = [];
    // this.files = [];
    this.cloudFile.fileName = uploadingFile.name;
    this.cloudFile.fileSize = this.humanizeBytes(uploadingFile.size);

    if (uploadingFile.size > this.sizeLimit) {
      // this.uploadInput.emit({ type: 'cancelAll' })
      this.notificationService.largeFileToUpload();
    }

    if(uploadingFile.name.length > 88){
      // this.uploadInput.emit({ type: 'cancelAll' })
    }

    let match = (/\.(gif|jpg|jpeg|png|pdf)$/i).test(uploadingFile.name);

    if (!match) {
      // this.uploadInput.emit({ type: 'cancelAll' })
      this.notificationService.fileTypeNotMatchToUpload();
    } else {
      // if(this.files.indexOf(uploadingFile) == -1) {
      //   this.files.push(uploadingFile);
      // }
    }
  }

  handleUpload(data:any):void {
    console.log("handleUpload",data)
    let initialize = false;

    this.zone.run(() => {
      // this.uploadFile = data;
    });

    setTimeout(() => {
      if (this.screenState != "FINISHED" && !initialize) {
        this.screenState = "UPLOADING";
      }
    });

  }

  responseArrived() {

  }

  onNavigationEvent(event: NavigationEvent){
    if(event.acton=="NEW_JOB"){
      //reset parameters
      this.newJob();

    }
  }

  /** Utilities used in your template */
  humanizeBytes(bytes?: number): string {
    if (!bytes && bytes !== 0) return '';
    const thresh = 1024;
    if (Math.abs(bytes) < thresh) return bytes + ' B';
    const units = ['KB', 'MB', 'GB', 'TB'];
    let u = -1;
    do {
      bytes /= thresh;
      ++u;
    } while (Math.abs(bytes) >= thresh && u < units.length - 1);
    return `${bytes.toFixed(1)} ${units[u]}`;
  }

  ngOnDestroy(){
    $('.modal-backdrop').remove(); //browser ileri-geri tuşuna basıncaki kırıklığı önlemek

    // Tear down Uppy (Dashboard + Drive/Box plugins) and remove the per-open modal reset
    // hook + any orphaned native Google Picker overlay Google injects on body.
    this.uppy?.destroy();
    $('#newJob').off('shown.bs.modal.driveTokenReset');
    $('.picker-dialog, .picker-dialog-bg').remove();

    this.subscriptions.forEach(
      (s: Subscription) => s.unsubscribe()
    );
  }

}
